<template>
  <div id="app">
   <router-view  :key="$route.fullPath" />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {}
}
</script>

<style>
	*{
		padding: 0;
		margin: 0;
	}
	a{
		text-decoration: none;
		color: #000;
	}
	.router-link-active{
		color: #000;
		text-decoration: none;
	}
</style>
